import React, { forwardRef } from "react";
import styles from './CustomDateRangePicker.module.scss';
import DatePicker from "react-datepicker";
import PropTypes from "prop-types";
import {ReactComponent as CalendarIcon} from './Calendar.svg';
import {ReactComponent as ChevronDownIcon} from './ChevronDown.svg';

const CustomInput = forwardRef(
  ({ value, onClick }, ref) => (
    <div onClick={onClick} ref={ref} className={styles.input}>
      <CalendarIcon />
      {value}
      <ChevronDownIcon />
    </div>
  ),
);

CustomInput.displayName = "CustomInput"

CustomInput.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func
}

const CustomDateRangePicker = ({
  startDate,
  endDate,
  onChange
}) => {
  return (
    <DatePicker
      startDate={startDate}
      endDate={endDate}
      onChange={(dates) => {
        const [start, end] = dates;
        onChange(start, end);
      }}
      selectsRange
      customInput={<CustomInput />}
    />
  );
};

CustomDateRangePicker.propTypes = {
  startDate: PropTypes.any.isRequired,
  endDate: PropTypes.any,
  onChange: PropTypes.func.isRequired
}

export default CustomDateRangePicker;